import {
  CLEAR_STATE,
  FLUSH_READY_TO_SAVE,
  SET_ACTIVE_MODULE,
  SET_FORM_ERROR,
  SET_LOADING_STATE,
  SET_MODULE_CHANGED,
  SET_READY_TO_SAVE,
  SET_SAVING_METHOD,
  SET_SAVING_STATE,
  UPDATE_FORM,
} from './constants'

const settingsReducer = (state, action) => {
  switch (action.type) {
    case SET_ACTIVE_MODULE:
      return { ...state, activeTab: action.value }
    case SET_MODULE_CHANGED:
      return {
        ...state,
        moduleChanged: {
          ...state.moduleChanged,
          [action.module]: action.value,
        },
      }
    case SET_READY_TO_SAVE:
      return {
        ...state,
        readyToSave: {
          ...state.readyToSave,
          [action.module]: action.value,
        },
      }
    case FLUSH_READY_TO_SAVE:
      return {
        ...state,
        readyToSave: {},
      }
    case SET_FORM_ERROR:
      return {
        ...state,
        moduleErrors: {
          ...state.moduleErrors,
          [action.module]: {
            ...(action.overwriteMode ? {} : state.moduleErrors[action.module]),
            ...action.keyValuePair,
          },
        },
      }
    case SET_LOADING_STATE:
      return {
        ...state,
        loading: action.value,
      }
    case SET_SAVING_STATE:
      return {
        ...state,
        saving: action.value,
      }
    case SET_SAVING_METHOD:
      return {
        ...state,
        moduleInfo: {
          ...state.moduleInfo,
          [action.module]: {
            ...state.moduleInfo[action.module],
            save: action.value,
          },
        },
      }
    case UPDATE_FORM:
      return {
        ...state,
        consolidatedForm: {
          ...state.consolidatedForm,
          [action.module]: {
            ...(action.overwriteMode
              ? {}
              : state.consolidatedForm[action.module]),
            ...action.keyValuePair,
          },
        },
      }
    case CLEAR_STATE:
      return action.initialState
    default:
      throw new Error('Unknown action')
  }
}

export default settingsReducer
